import { Alert } from "reactstrap";

import styles from "Pages/Integration/Components/RunToasts/RunToasts.module.css";

export interface IRunToast {
    id: number;
    message: string;
}

/**
 * Persistent, stacking toasts for inline home-page job runs (the "run_inline"
 * preference). Deliberately separate from the shared AlertContextProvider,
 * which shows one auto-dismissing alert at a time: when a user queues several
 * contracts in a row they need to see every result, so these stack and stay up
 * until dismissed by hand. State lives in the parent (Integrations.tsx).
 */
export default function RunToasts({
    toasts,
    onDismiss,
}: {
    toasts: IRunToast[];
    onDismiss: (id: number) => void;
}) {
    if (toasts.length === 0) return null;

    return (
        <div className={styles.stack} aria-live="polite">
            {toasts.map((toast) => (
                <Alert
                    key={toast.id}
                    color="success"
                    className={styles.toast}
                    isOpen={true}
                    toggle={() => onDismiss(toast.id)}
                >
                    {toast.message}
                </Alert>
            ))}
        </div>
    );
}
